import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { VkMusicErrorModalProps } from './VkMusicErrorModal';

export const renderVkMusicErrorModal = (data: VkMusicErrorModalProps) => {
    openPopupHelper({
        popupName: popupNames.VK_MUSIC_ERROR_MODAL,
        data,
        onClose: data.onClose,
    });
};

export const closeVkMusicErrorModal = () => closePopupHelper(popupNames.VK_MUSIC_ERROR_MODAL);
